module.exports = __webpack_public_path__ + "img/ico_checkout_step_3.bda30c73.svg";